import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { getPostAuthRedirect } from "@/lib/authRedirect";
import { CircleNotch } from "@phosphor-icons/react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      const sessionId = window.location.hash.split("session_id=")[1]?.split("&")[0];
      if (!sessionId) {
        navigate("/login", { replace: true });
        return;
      }
      try {
        const res = await api.post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } });
        setUser(res.data);
        window.history.replaceState(null, "", window.location.pathname);
        const destination = await getPostAuthRedirect(res.data);
        navigate(destination, { replace: true, state: { user: res.data } });
      } catch (e) {
        navigate("/login", { replace: true });
      }
    };
    processSession();
  }, [navigate, setUser]);

  return (
    <div className="flex h-screen w-full items-center justify-center bg-background" data-testid="auth-callback-loading">
      <CircleNotch className="h-8 w-8 animate-spin text-primary" />
    </div>
  );
}
